var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogofull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 77,
    viewBox: "0 0 271 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6523 69.5399C33.9414 65.3173 37.2305 61.0946 40.5196 56.8719C42.9492 53.7552 45.5006 50.6987 47.7543 47.448C49.8117 44.4854 52.2345 41.1005 52.8639 37.4878C55.4762 41.1877 57.0599 46.7241 55.192 51.0607C54.5964 52.4481 53.1955 53.8021 51.6592 53.7887C51.6051 53.7887 51.551 53.7887 51.5036 53.7887C50.2042 53.7887 49.1552 52.8838 49.1552 51.7645C49.1552 51.5567 49.1958 51.3489 49.2635 51.1612C49.5071 50.4172 50.2448 49.814 51.2396 49.7537C51.3276 49.747 51.4156 49.7403 51.5103 49.7403C51.5916 49.7403 51.6728 49.7403 51.754 49.7537C50.7253 48.9695 49.0401 49.2778 48.4852 50.491C47.8558 51.865 48.3228 52.7766 48.8777 54.0166C50.6238 57.8907 47.4024 60.8064 45.1826 63.6483C41.995 67.7369 38.8074 71.8255 35.6198 75.9209C33.9617 73.7961 32.3037 71.6714 30.6523 69.5466V69.5399Z",
    fill: "url(#paint0_linear_355_1993)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9284 50.7122C23.4988 47.5955 20.9474 44.5391 18.6938 41.2883C16.6364 38.3257 14.2135 34.9409 13.5842 31.3281C10.9718 35.028 9.38819 40.5644 11.2561 44.901C11.8516 46.2885 13.2525 47.6424 14.7888 47.629C14.8429 47.629 14.8903 47.629 14.9445 47.629C16.2439 47.629 17.2928 46.7241 17.2928 45.6048C17.2928 45.397 17.259 45.1892 17.1846 45.0016C16.9409 44.2576 16.2032 43.6543 15.2084 43.594C15.1204 43.5873 15.0324 43.5806 14.9377 43.5806C14.8565 43.5806 14.7753 43.5806 14.6941 43.594C15.7295 42.8098 17.4079 43.1181 17.9628 44.3313C18.5922 45.7053 18.1253 46.6169 17.5703 47.8569C15.8243 51.731 19.0457 54.6467 21.2655 57.4886C26.057 63.635 30.8417 69.788 35.6333 75.9344C37.2914 73.8096 38.9494 71.6849 40.6008 69.5534C35.7077 63.273 30.8147 56.9926 25.9216 50.7189L25.9284 50.7122Z",
    fill: "url(#paint1_linear_355_1993)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1177 50.7796C32.5473 47.6629 35.0987 44.6065 37.3523 41.3557C39.4097 38.3931 41.8325 35.0082 42.4619 31.3955C45.0742 35.0954 46.6579 40.6318 44.79 44.9684C44.1944 46.3559 42.7935 47.7098 41.2573 47.6964C41.2031 47.6964 41.149 47.6964 41.1016 47.6964C39.8022 47.6964 38.7532 46.7915 38.7532 45.6722C38.7532 45.4644 38.7871 45.2566 38.8615 45.0689C39.1051 44.3249 39.8428 43.7217 40.8377 43.6614C40.9257 43.6547 41.0136 43.648 41.1084 43.648C41.1896 43.648 41.2708 43.648 41.352 43.6614C40.3233 42.8772 38.6382 43.1855 38.0832 44.3987C37.4538 45.7727 37.9208 46.6843 38.4757 47.9243C40.2218 51.7984 37.0004 54.7141 34.7806 57.556C29.9891 63.7024 25.2043 69.8554 20.4128 76.0018C18.7547 73.877 17.0966 71.7523 15.4453 69.6208C20.3383 63.3404 25.2314 57.06 30.1244 50.7796H30.1177Z",
    fill: "url(#paint2_linear_355_1993)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3599 69.6205C22.0708 65.3978 18.7817 61.1751 15.4926 56.9525C13.063 53.8357 10.5116 50.7793 8.25796 47.5285C6.20059 44.5659 3.77776 41.1811 3.14836 37.5684C0.536034 41.2682 -1.0476 46.8046 0.820277 51.1413C1.41583 52.5287 2.81674 53.8827 4.35301 53.8692C4.40715 53.8692 4.46129 53.8692 4.50867 53.8692C5.80806 53.8692 6.85705 52.9644 6.85705 51.845C6.85705 51.6373 6.81645 51.4295 6.74877 51.2418C6.50513 50.4978 5.76746 49.8946 4.7726 49.8342C4.68463 49.8275 4.59665 49.8208 4.5019 49.8208C4.42069 49.8208 4.33947 49.8208 4.25826 49.8342C5.29372 49.05 6.9721 49.3583 7.52705 50.5715C8.15645 51.9456 7.68948 52.8571 7.13453 54.0971C5.38846 57.9713 8.60988 60.8869 10.8297 63.7289C14.0173 67.8175 17.2048 71.9061 20.3857 76.0014C22.0437 73.8767 23.7018 71.752 25.3531 69.6272L25.3599 69.6205Z",
    fill: "url(#paint3_linear_355_1993)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.094 16.2471H27.2683V16.7431H28.094V16.2471Z",
    fill: "url(#paint4_linear_355_1993)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1074 21.8643V23.7812H24.4867L22.5173 21.9179L28.1074 21.8643Z",
    fill: "url(#paint5_linear_355_1993)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4297 28.7274L20.9134 31.308H28.1075V28.5264L18.4297 28.7274Z",
    fill: "url(#paint6_linear_355_1993)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9331 16.2407H28.0872V16.7367H28.9331V16.2407Z",
    fill: "url(#paint7_linear_355_1993)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0872 0V16.3143H29.3595C29.3595 16.3143 28.4865 4.87954 28.0872 0Z",
    fill: "url(#paint8_linear_355_1993)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0939 0V16.3143H26.8215C26.8215 16.3143 27.6946 4.87954 28.0939 0Z",
    fill: "url(#paint9_linear_355_1993)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.094 21.8643V23.7812H31.7282L33.6976 21.9179L28.094 21.8643Z",
    fill: "url(#paint10_linear_355_1993)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7718 28.7274L35.288 31.308H28.094V28.5264L37.7718 28.7274Z",
    fill: "url(#paint11_linear_355_1993)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2684 16.7231L22.5039 21.9177H28.1076V16.7231H27.2752H27.2684ZM22.707 29.6928L17.2793 33.1983C18.2132 34.8404 19.3164 36.4089 20.3315 37.8701C22.5852 41.1208 25.1366 44.1773 27.5662 47.294C27.7421 47.5219 27.9249 47.7498 28.1008 47.9844V31.0803L26.7338 29.6928H22.707ZM25.5968 22.7421L18.4298 28.741H28.1008V23.7811L27.2007 22.7421H25.5968Z",
    fill: "url(#paint12_linear_355_1993)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0805 16.7231V21.9177H33.6841L28.9197 16.7231H28.0873H28.0805ZM29.4476 29.6928L28.0805 31.0803V47.9844C28.2565 47.7565 28.4392 47.5286 28.6151 47.294C31.0447 44.1773 33.5962 41.1208 35.8498 37.8701C36.865 36.4089 37.9681 34.8404 38.902 33.1983L33.4743 29.6928H29.4476ZM28.9738 22.7421L28.0737 23.7811V28.741H37.7448L30.5778 22.7421H28.9738Z",
    fill: "url(#paint13_linear_355_1993)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M119.424 25.3788C125.869 25.3788 130.6 26.7273 133.822 29.7151C136.388 32.0627 138.357 35.5453 138.357 40.58C138.357 46.3132 135.938 50.6979 132.069 53.5888C128.347 56.3826 123.557 57.7795 117.827 57.7795H103.987V55.9364C107.817 55.6356 108.267 55.1894 108.267 51.0472V32.1015C108.267 27.9107 107.709 27.513 103.987 27.2123V25.3691H119.443L119.424 25.3788ZM115.241 50.7076C115.241 54.2484 116.142 55.4416 119.825 55.4416C126.623 55.4416 130.551 50.7561 130.551 41.3367C130.551 36.6027 129.238 32.4604 126.926 30.3165C124.811 28.2212 122.196 27.5227 118.826 27.5227C116.965 27.5227 116.103 27.9205 115.809 28.2212C115.359 28.6674 115.251 29.5211 115.251 30.9665V50.7076H115.241Z",
    fill: "url(#paint14_linear_355_1993)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M208.166 49.0392C207.921 50.3585 206.54 55.985 206.089 57.3528H180.456V55.5872C184.952 55.1507 185.246 54.8985 185.246 50.795V32.1113C185.246 27.9496 184.648 27.6586 181.298 27.3676V25.5535H197.352C202.534 25.5535 204.267 25.505 204.963 25.4565C205.012 26.3393 205.257 30.3457 205.452 33.3821L203.523 33.6246C203.082 31.9658 202.24 29.9577 201.397 29.0749C200.506 28.0952 199.869 27.8041 197.342 27.8041H194.129C192.249 27.8041 192.053 27.9011 192.053 29.5697V39.7943H196.892C199.654 39.7943 200.153 39.0571 200.898 35.5842H202.827V46.4976H200.898C200.104 42.8792 199.713 42.2874 196.843 42.2874H192.053V50.698C192.053 54.0739 192.151 55.1022 195.217 55.1507H198.723C201.485 55.1507 202.23 54.8112 203.317 53.4919C204.551 52.0756 205.541 50.2615 206.334 48.6027L208.166 49.0392Z",
    fill: "#6A0A12"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M242.154 57.6532C241.86 57.6532 241.263 57.6532 240.675 57.6047C234.406 57.3137 232.574 55.9944 231.095 53.9378C229.117 51.2507 227.687 48.2629 226.012 45.3235C225.267 44.0042 224.582 43.7132 222.995 43.7132L222.006 43.6647V50.8045C222.006 54.7624 222.496 55.1116 226.208 55.5482V57.3622H211.094V55.5482C214.846 55.1601 215.296 54.7624 215.296 50.8045V32.0722C215.296 28.2113 214.807 27.6681 211.094 27.377V25.563H225.414C229.812 25.563 232.33 26.048 234.357 27.4255C236.336 28.7449 237.668 30.8984 237.668 33.9348C237.668 38.2904 234.749 40.5895 231.497 41.8603C232.241 43.3252 234.161 46.507 235.65 48.7576C237.374 51.4447 238.461 52.764 239.402 53.8408C240.538 55.1116 241.076 55.4997 242.516 55.9944L242.173 57.6532H242.154ZM223.338 41.6566C225.463 41.6566 227.089 41.3171 228.177 40.3858C229.803 39.018 230.498 37.1554 230.498 34.6623C230.498 29.4724 227.481 27.6196 224.719 27.6196C223.387 27.6196 222.74 27.8136 222.447 28.1046C222.104 28.3956 222.006 28.9874 222.006 29.9672V41.6566H223.338Z",
    fill: "#6A0A12"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M258.257 25.563C262.155 25.563 265.123 26.2517 267.151 27.5711C269.619 29.1814 271 31.529 271 34.9049C271 41.9962 264.927 44.984 259.638 45.0325C259.148 45.0325 258.502 44.984 258.159 44.9355L255.299 44.1982V50.853C255.299 54.9661 255.642 55.1601 259.942 55.5482V57.3622H244.23V55.5482C247.933 55.1116 248.432 54.9661 248.432 50.853V32.1692C248.432 28.0561 247.943 27.6196 244.23 27.377V25.563H258.257ZM255.289 42.1514C255.877 42.4424 256.866 42.6364 257.904 42.6364C260.177 42.6364 263.879 41.3171 263.879 34.8564C263.879 29.3754 260.862 27.5711 257.659 27.5711C256.621 27.5711 256.033 27.8136 255.73 28.0561C255.387 28.3471 255.289 28.8419 255.289 29.5694V42.1417V42.1514Z",
    fill: "#6A0A12"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.364 25.4565C92.3407 25.4565 95.3576 26.155 97.4243 27.5034C99.9416 29.1525 101.352 31.5389 101.352 34.9827C101.352 42.2098 95.1617 45.2559 89.7745 45.3044C89.2749 45.3044 88.6187 45.2559 88.2661 45.2074L85.3472 44.4604V51.2413C85.3472 55.432 85.6998 55.626 90.0781 56.0238V57.8669H74.0732V56.0238C77.8443 55.5775 78.3536 55.4223 78.3536 51.2413V32.1986C78.3536 28.0079 77.8541 27.5616 74.0732 27.3094V25.4662H88.3738L88.364 25.4565ZM85.3472 42.3553C85.9545 42.6561 86.9535 42.8501 88.0114 42.8501C90.323 42.8501 94.1038 41.5017 94.1038 34.9245C94.1038 29.3369 91.0282 27.4937 87.7567 27.4937C86.6989 27.4937 86.0916 27.7459 85.7977 27.9884C85.4451 28.2892 85.3472 28.7839 85.3472 29.5309V42.3456V42.3553Z",
    fill: "url(#paint15_linear_355_1993)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M144.714 51.1928C145.214 49.6504 145.929 47.7587 146.477 46.2066H156.292C155.969 45.3626 155.665 44.5089 155.342 43.665H147.339C148.603 40.0369 150.004 36.6998 151.463 33.1105C151.071 32.0822 150.66 31.0636 150.219 30.0645L142.109 50.0481C140.395 54.2292 139.592 54.6851 136.418 55.0828V56.926H148.857V55.0828C144.881 54.7336 143.666 54.3359 144.724 51.1928H144.714Z",
    fill: "url(#paint16_linear_355_1993)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M169.427 54.5589C168.153 54.0059 167.546 52.8321 166.283 49.6988C166.185 49.4466 166.067 49.1943 165.959 48.9421C164.941 46.2065 163.922 43.4612 162.903 40.7255C161.836 37.8444 161.101 34.3424 158.398 32.8679C157.83 32.5575 157.193 32.344 156.439 32.2373C155.048 32.0433 153.98 31.9463 153.118 30.6367C152.344 29.492 153.001 27.872 154.254 27.4063C154.205 27.4742 154.156 27.5421 154.117 27.6101C154.068 27.6877 154.019 27.775 153.98 27.8526C153.49 28.7353 153.618 29.7151 154.137 30.336C154.274 30.5009 154.431 30.6464 154.617 30.7531C155.489 31.2964 156.654 31.0441 157.399 30.2099C157.516 30.0935 157.614 29.9771 157.692 29.8315L157.771 29.6957C158.623 28.3667 158.202 26.4169 157.31 25.1364C154.509 21.1396 148.75 19.4711 144.048 19.7039C146.889 22.2358 148.544 26.184 150.033 29.5987C150.101 29.7539 150.17 29.8994 150.229 30.0547C150.669 31.0635 151.081 32.0821 151.473 33.1007C151.561 33.3529 151.669 33.5955 151.757 33.8477C152.178 34.973 152.589 36.108 153.001 37.2333C153.461 38.5041 153.912 39.7652 154.382 41.0263L155.361 43.6455C155.684 44.4895 155.988 45.3431 156.311 46.1871L157.448 49.2428L157.467 49.3011C157.82 50.2808 158.133 51.1927 158.378 51.9203C159.083 54.0642 159.083 54.6171 155.91 55.0633V56.9065H171.885V55.0633C170.827 54.9372 170.054 54.8111 169.446 54.5492L169.427 54.5589Z",
    fill: "url(#paint17_linear_355_1993)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_355_1993",
    x1: 34.2866,
    y1: 75.1501,
    x2: 55.0908,
    y2: 38.7616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#B1421E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CF6F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FBB211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1551E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_355_1993",
    x1: 36.5198,
    y1: 75.425,
    x2: 11.8669,
    y2: 32.3084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#6A0A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6E0B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7C1013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#931915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#B32517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DC341B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E8391C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#8E0E19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_355_1993",
    x1: 19.5262,
    y1: 75.4924,
    x2: 44.1791,
    y2: 32.3758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#B1421E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CF6F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FBB211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1551E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_355_1993",
    x1: 21.7257,
    y1: 75.2373,
    x2: 0.914764,
    y2: 38.8421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#6A0A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6E0B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7C1013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#931915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#B32517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DC341B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E8391C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#8E0E19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_355_1993",
    x1: 27.4713,
    y1: 16.8637,
    x2: 27.8848,
    y2: 16.1297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#B1421E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CF6F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FBB211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1551E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_355_1993",
    x1: 24.6965,
    y1: 23.9019,
    x2: 26.4174,
    y2: 20.8914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#B1421E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CF6F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FBB211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1551E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_355_1993",
    x1: 22.1113,
    y1: 31.9983,
    x2: 25.0862,
    y2: 26.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#B1421E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CF6F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FBB211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1551E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_355_1993",
    x1: 28.7233,
    y1: 16.8574,
    x2: 28.3031,
    y2: 16.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A0A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#770A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A60A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B80B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E0E19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_355_1993",
    x1: 25.0011,
    y1: 14.5515,
    x2: 32.0314,
    y2: 2.25365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#B1421E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#CF6F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FBB211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F9AE11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3A213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB8E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#DE7319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1551E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_355_1993",
    x1: 31.1799,
    y1: 14.5448,
    x2: 24.1496,
    y2: 2.25364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A0A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A72016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D6321A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E8391C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E0E19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_355_1993",
    x1: 29.3663,
    y1: 24.5051,
    x2: 31.5475,
    y2: 20.6932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A0A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#790E13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#A01916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E02C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E72E1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E0E19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_355_1993",
    x1: 30.5507,
    y1: 32.7155,
    x2: 34.0458,
    y2: 26.6003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A0A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#790E13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#A01916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E02C1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E72E1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E0E19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_355_1993",
    x1: 34.1105,
    y1: 44.5392,
    x2: 20.4367,
    y2: 20.6237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A0A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#6F0B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#7D1113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#961A15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#B82718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E4371B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E8391C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E0E19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_355_1993",
    x1: 22.0776,
    y1: 44.5392,
    x2: 35.7514,
    y2: 20.6304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#B1421E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CF6F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FBB211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1551E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_355_1993",
    x1: 123.792,
    y1: 57.6922,
    x2: 114.047,
    y2: 21.1602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#6A0A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6E0B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7C1013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#931915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#B32517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DC341B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E8391C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#8E0E19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_355_1993",
    x1: 93.1929,
    y1: 65.8604,
    x2: 83.4382,
    y2: 29.3283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#6A0A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6E0B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7C1013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#931915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#B32517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DC341B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E8391C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B11F1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#8E0E19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_355_1993",
    x1: 142.873,
    y1: 59.3027,
    x2: 152.631,
    y2: 34.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#B1421E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CF6F18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FBB211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1551E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_355_1993",
    x1: 168.173,
    y1: 61.3689,
    x2: 144.921,
    y2: 19.6769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#6A0A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6E0B12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7C1013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#931915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#B32517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DC341B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E8391C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#8E0E19"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogofull);
export default __webpack_public_path__ + "static/media/logofull.6e5ce6d084bc1807f37951162d9b2b7d.svg";
export { ForwardRef as ReactComponent };